import {VGLawCookie} from "vglawcookie";

var lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.bg();
		Vegas.location();
		Vegas.enablePlugins();
		Vegas.user();
		Vegas.fixedHeader($(window));
		Vegas.fixedProduct($(window));
		Vegas.fixedOrderProduct($(window));
		Vegas.fixedScrollTop($(window));
		Vegas.maps();
		Vegas.carousel();
		Vegas.snow();
		Vegas.sales();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
		Vegas.popupClose();
		Vegas.toggle();
		Vegas.yaGoal();
	},

	onSubmit: () => {
		Vegas.forms();
	},

	onScroll: ($self) => {
		Vegas.fixedHeader($self);
		Vegas.fixedProduct($self);
		Vegas.fixedOrderProduct($self);
		Vegas.fixedScrollTop($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	snow: function () {
		let $wrapper = $('.theme-ny');
		$wrapper.find('.main-snow2').css('height', $wrapper.height());
		$wrapper.find('.main-snow3').css('height', $wrapper.height());
		$wrapper.find('.main-snow').css('height', $wrapper.height());

		$('.main-snow').snowfall({
			flakeCount: isMobile() ? 7 : 50,
			minSize: 3,
			round: true,
			flakeIndex: 10,
			maxSize: 13,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 2,
			image: '/assets/_frontend/images/theme/2022/ny/snow3.png'
		});

		$('.main-snow3').snowfall({
			flakeCount: isMobile() ? 7 : 70,
			minSize: 5,
			round: true,
			flakeIndex: 10,
			maxSize: 15,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 3,
			image: '/assets/_frontend/images/theme/2022/ny/snow1.png'
		});

		$('.main-snow2').snowfall({
			flakeCount: isMobile() ? 7 : 100,
			minSize: 2,
			round: true,
			flakeIndex: 10,
			maxSize: 10,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 1,
			image: '/assets/_frontend/images/theme/2022/ny/2.png'
		});
	},

	sales: function () {
		let $wrapper = $('.theme-blackFriday');
		$wrapper.find('.sales1').css('height', $wrapper.height());
		$wrapper.find('.sales2').css('height', $wrapper.height());
		$wrapper.find('.sales3').css('height', $wrapper.height());
		$wrapper.find('.sales4').css('height', $wrapper.height());

		$('.sales1').snowfall({
			flakeCount: isMobile() ? 3 : 10,
			minSize: 16,
			round: true,
			flakeIndex: 10,
			maxSize: 36,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 2,
			image: '/assets/_frontend/images/theme/2022/bf/sales1.png'
		});

		$('.sales2').snowfall({
			flakeCount: isMobile() ? 3 : 10,
			minSize: 12,
			round: false,
			flakeIndex: 5,
			maxSize: 36,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 3,
			image: '/assets/_frontend/images/theme/2022/bf/sales2.png'
		});

		$('.sales3').snowfall({
			flakeCount: isMobile() ? 3 : 10,
			minSize: 14,
			round: false,
			flakeIndex: 5,
			maxSize: 36,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 1,
			image: '/assets/_frontend/images/theme/2022/bf/sales3.png'
		});

		$('.sales4').snowfall({
			flakeCount: isMobile() ? 3 : 10,
			minSize: 8,
			round: false,
			flakeIndex: 5,
			maxSize: 36,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 1,
			image: '/assets/_frontend/images/theme/2022/bf/sales4.png'
		});
	},

	location: function () {
		$('.saveLocation').click(function () {
			GeoLocation.saveLocation();
			return false;
		});
		$('.closeLocation').click(function () {
			GeoLocation.closeLocation();
			return false;
		});

		$('#getChangeLocation').on('shown.bs.modal', function (e) {
			let $container = $("#geoLocation");

			$container.closest('.dropdown').removeClass('show');
			$container.removeClass('show');

			cities.getList();

			return false;
		});

		$('.findCity').on('change input', function () {
			let val = $(this).val();
			cities.findCity(val);
		});

		GeoLocation.getLocation();
	},

	preloader: function () {

	},

	forms: function () {

	},

	toggle: function () {

	},

	enablePlugins: function () {
		// input mask
		$('input').inputmask();
		$('.input-mask-phone').inputmask('8 (\\999) 999-99-99', {"clearIncomplete": true});

		// vg nav
		$('.vg-nav').vegasMenu();

		// niceSelect;
		$(".nice-select").niceSelect();

		// tags
		$('.subCategories-wrapper').vegasCountElement();

		//
		Adult.run();

		//
		new VGLawCookie({
			privacyLink: '/privacy-policy'
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			let target = $(this).data('modal'),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false,
				store = $(this).data('store') || false,
				focus = $(this).data('focus') || false;

			if (title) {
				$(target).find('.modal-title').text(title);
			}

			if (id) {
				$(target).find('form input[name=id], .input-id').val(id);
			}

			if (focus) {
				setTimeout(() => {
					let $input = $(target).find('input');
					$input.focus();

					if($input.val()) {
						$input.change()
					}

				}, 10);
			}

			if (store) {
				$(target).find('.modal-title').text(store['city'] + ', ' +  store['address']);
				$body.attr('data-map-open', target);
				YaMap.mapStores(store);
			}

			$(target).modal('show');

			return false;
		});
	},

	popupClose: function () {
		$('.vg-modal').on('hide.bs.modal', function (e) {
			if($body.hasClass('modal-open')) {
				let map = $body.attr('data-map-open');

				if($(map).length) {
					$(map).find('ymaps').remove();
				}
			}
		});
	},

	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},

	fixedHeader: function($self) {
		let $sticky = $('.vg-hdr-sticky, .vg-hdr-mobile > .vg-hdr-top'),
			scroll = $self.scrollTop(),
			fTop = 0,
			sTop = 0;

		if (window.innerWidth >= 768) {
			fTop = 345;
			sTop = -70;
		} else if(window.innerWidth < 768) {
			fTop = 445;
			sTop = -100;
		}

		if (scroll > fTop) {
			$body.addClass('vg-hdr--is-scroll');
			$sticky.addClass('is-sticky');

			if (scroll > lastScrollTop) {
				$sticky.css('top', sTop);
				$body.removeClass('vg-hdr--is-fixed');
			} else {
				$sticky.css('top', 0);
				$body.addClass('vg-hdr--is-fixed');
			}

			lastScrollTop = scroll;
		} else {
			$sticky.css('top', sTop).removeClass('is-sticky');
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}

		Vegas.removeClasses('.vg-dropdown-content', 'vg-hdr--is-scroll');
		Vegas.removeClasses('.vg-search-content', 'vg-hdr--is-fixed');
	},

	fixedScrollTop: function($self) {
		let $sticky = $('.vg-scrollToTop'),
			scroll = $self.scrollTop();

		if (scroll > 545) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedProduct: function($self) {
		let $sticky = $('.vg-catalog-product__fixed'),
			scroll = $self.scrollTop();

		if($sticky.length) {
			if (scroll > 700) {
				$body.addClass('vg-prd--is-scroll');

				if($body.hasClass('vg-hdr--is-fixed')) {
					$sticky.css('top', 70);
				} else {
					$sticky.css('top', 0);
				}
			} else {
				$sticky.css('top', -110);
				$body.removeClass('vg-prd--is-scroll');
			}
		}
	},

	fixedOrderProduct: function ($self) {
		let $sticky = $('.vg-shop-order__sticky');

		if($sticky.length) {
			if($body.hasClass('vg-hdr--is-fixed')) {
				$body.addClass('vg-shop-order__sticky--is-scroll');
				$sticky.css('top', 80);
			} else {
				$sticky.css('top', 5);
				$body.removeClass('vg-shop-order__sticky--is-scroll');
			}
		}
	},

	removeClasses: function (target, bodyClass = '') {
		/* Sticky Categories */
		if (target === '.vg-dropdown-content') {
			let $drop_content = $(target);

			if (!$body.hasClass(bodyClass) && $drop_content.hasClass('show')) {
				$drop_content.removeClass('show');
			}
		}

		/* Sticky Search */
		if (target === '.vg-search-content') {
			if (!$body.hasClass(bodyClass) && $(target).hasClass('focused')) $(target).removeClass('focused');
		}
	},

	yaGoal: function () {
		$(document).on('click', '[data-yagoal]', function () {
			let goal = $(this).data('yagoal');
			yaCounterReachGoal(goal);
		});
	},

	user: function () {
		let getRequestError = function (xhr, fallback) {
			let response = xhr.responseJSON;

			if (!response && xhr.responseText) {
				try {
					response = JSON.parse(xhr.responseText);
				} catch (e) {
					response = null;
				}
			}

			if (response) {
				if (response.error && typeof response.error === 'string') {
					return response.error;
				}

				if (response.errors) {
					let fields = Object.keys(response.errors);

					if (fields.length && response.errors[fields[0]].length) {
						return response.errors[fields[0]][0];
					}
				}

				if (response.message) {
					return response.message;
				}
			}

			return fallback;
		};

		let setFormBusy = function (form, busy) {
			let $submit = $(form).find('[type="submit"]');

			$submit.each(function () {
				let $button = $(this);

				if (!$button.data('default-text')) {
					$button.data('default-text', $button.html());
				}

				$button
					.prop('disabled', busy)
					.html(busy ? ($button.data('loading-text') || 'Подождите...') : $button.data('default-text'));
			});
		};

		$('#forgot, #cancel-forgot').click(function (event) {
			event.preventDefault();

			let $forgotForm = $('#forgot-form');

			$forgotForm.find('.result').stop(true, true).hide();
			$forgotForm.find('.form-control-email').show();
			$('#login-form').stop(true, true).slideToggle();
			$forgotForm.stop(true, true).slideToggle();
		});

		$('.deleteMethod').click(function () {
			let $self = $(this);
			let $card = $self.closest('.card');

			if (confirm('Вы действительно хотите удилить этот метод доставки?')) {
				let params = {
					id: $card.data('id'),
					_token: App.csrf

				};

				$.post($self.attr('href'), params, function () {
					$card.slideUp();
				});
			}

			return false;
		});

		$("#login-form").submit(function (event) {
			event.preventDefault();

			let data = $(this).serializeArray();
			let form = this;

			$(form).find('.result').slideUp('slow');
			setFormBusy(form, true);

			$.ajax({
				type: "POST",
				url: $(form).attr('action'),
				data: data,
				success: function (data) {
					if (data.redirect_to) {
						location.href = data.redirect_to;
					} else {
						location.reload();
					}
				},
				error: function (xhr) {
					$(form).find('.result')
						.html(getRequestError(xhr, 'Неверный e-mail или пароль'))
						.slideDown('slow');
				},
				complete: function () {
					setFormBusy(form, false);
				}
			});
		});

		$("#forgot-form").submit(function (event) {
			event.preventDefault();

			let data = $(this).serializeArray();
			let form = this;
			let $emailGroup = $(form).find('.form-control-email');

			$(form).find('.result').slideUp('slow');
			setFormBusy(form, true);

			$.ajax({
				type: "POST",
				url: $(form).attr('action'),
				data: data,
				success: function (data) {
					if (data.error) {
						$emailGroup.slideDown();
						$(form).find('.result.error').html(data.error).slideDown();
						$(form).find('input[name="email"]').focus();
					} else {
						$emailGroup.slideUp();
						$(form).find('.result.success').slideDown();
					}
				},
				error: function (xhr) {
					$emailGroup.slideDown();
					$(form).find('.result.error')
						.html(getRequestError(xhr, 'Не удалось отправить письмо. Попробуйте еще раз.'))
						.slideDown();
					$(form).find('input[name="email"]').focus();
				},
				complete: function () {
					setFormBusy(form, false);
				}
			});
		});

		$("#resetp-form").submit(function (event) {
			event.preventDefault();

			let data = $(this).serializeArray();
			let form = this;

			$(form).find('.result').slideUp('slow');
			setFormBusy(form, true);

			let treat = function (data) {
				if (data && typeof data.error != 'undefined') {
					if (data.error === false) {
						$(form).find('.result.success').slideDown();
						setTimeout(function () {
							location.href = data.redirect_to;
						}, 3000);
					} else {
						$(form).find('.result.error')
							.html(data.error)
							.slideDown();
					}
				} else if (data && data.errors) {
					let text = Object.values(data.errors)[0][0];
					$(form).find('.result.error').html(text).slideDown();
				} else {
					$(form).find('.result.error')
						.html('Не удалось изменить пароль. Попробуйте еще раз.')
						.slideDown();
				}
			};

			$.ajax({
				type: "POST",
				url: $(form).attr('action'),
				data: data,
				success: function (data) {
					treat(data);
				},
				error: function (xhr) {
					if (xhr.responseJSON) {
						treat(xhr.responseJSON);
					} else {
						$(form).find('.result.error')
							.html(getRequestError(xhr, 'Не удалось изменить пароль. Попробуйте еще раз.'))
							.slideDown();
					}
				},
				complete: function () {
					setFormBusy(form, false);
				}
			});
		});

		$("#formRegister").submit(function () {
			setFormBusy(this, true);
		});
	},

	maps: function () {
		YaMap.mapDelivery();
		YaMap.mapStores();
		YaMap.mapAllPointsPickups();
	},

	carousel: function () {
		let $owl = $('.owl-carousel');
		if ($owl.length) {
			$owl.each(function () {
				let $self = $(this);

				let custom = $self.data('custom') || false;

				if(custom) {
					let $owlCompare = $('.owl-compare');
					let $owlCompareOption = $('.owl-compare-option');

					$owlCompare.owlCarousel({
						loop: false,
						margin: 30,
						autoHeightClass: 'owl-height',
						autoplay: false,
						dots: false,
						nav: true,
						navText: ['<i class="icon fal fa-chevron-left">', '<i class="icon fal fa-chevron-right">'],
						responsive: {
							0: {
								items: 2
							},
							480: {
								items: 2
							},
							768: {
								items: 3
							},
							992: {
								items: 4
							},
							1200: {
								items: 5
							}
						}
					});

					$owlCompareOption.owlCarousel({
						loop: false,
						margin: 30,
						autoHeight: true,
						autoplay: false,
						dots: false,
						nav: false,
						mouseDrag: false,
						touchDrag: false,
						pullDrag: false,
						freeDrag: false,
						responsive: {
							0: {
								items: 2
							},
							480: {
								items: 2
							},
							768: {
								items: 3
							},
							992: {
								items: 4
							},
							1200: {
								items: 5
							}
						}
					});

					$owlCompare.on('change.owl.carousel', function (event) {
						if (event.namespace && event.property.name === 'position') {
							let target = event.relatedTarget.relative(event.property.value, true);
							$owlCompareOption.owlCarousel('to', target, 300, true);
						}
					});
				} else {
					let items = $self.data('items') || 1,
						loop = $self.data('loop') || false,
						autoplay = $self.data('autoplay') || false,
						autoplayTimeout = parseInt($self.data('autoplayTimeout')) || 5000,
						dots = $self.data('dots') || false,
						nav = $self.data('nav') || false,
						margin = parseInt($self.data('margin')) || 0,
						stagePadding = parseInt($self.attr('data-stagePadding')) || 0,
						animateOut = $self.attr('data-animateOut') || false,
						animateIn = $self.attr('data-animateIn') || false,
						smartSpeed = parseInt($self.attr('data-smartSpeed')) || 250,
						fluidSpeed = parseInt($self.attr('data-fluidSpeed')) || 250,
						autoWidth = $self.data('autowidth') || false,
						autoHeight = $self.data('autoheight') || false,
						responsive = {
							1200: {
								items: items
							},
							992: {
								items: items === 1 ? 1 : 4
							},
							768: {
								items: items === 1 ? 1 : 3
							},
							480: {
								items: items === 1 ? 1 : 2
							},
							0: {
								items: 1
							}
						};

					// responsive
					let xs = $self.data('xs') || false; // 0px
					if (xs) {
						let params = {
							0: xs
						};

						responsive = $.extend(responsive, params);
					}

					let sm = $self.data('sm') || false; // 480px
					if (sm) {
						let params = {
							480: sm
						};

						responsive = $.extend(responsive, params);
					}

					let md = $self.data('md') || false; // 768px
					if (md) {
						let params = {
							768: md
						};

						responsive = $.extend(responsive, params);
					}

					let lg = $self.data('lg') || false; // 992
					if (lg) {
						let params = {
							992: lg
						};

						responsive = $.extend(responsive, params);
					}

					let xl = $self.data('xl') || false; // 992
					if (xl) {
						let params = {
							1200: xl
						};

						responsive = $.extend(responsive, params);
					}

					// animation
					let animatedIn = {}, animatedOut = {};

					if (animateIn) {
						animatedIn = {
							animateIn: animateIn
						}
					}
					if (animateOut) {
						animatedOut = {
							animateOut: animateOut
						}
					}

					// navigation
					let navigation = {}, navText = {};
					if (nav) {

						switch (nav) {
							case 'chevron-icon':
								navText = {
									navText: ["<span class='vg-owl-chevron'><i class='fa fa-chevron-left'></i></span>", "<span class='vg-owl-chevron'><i class='fa fa-chevron-right'></i></span>"],
								};
								break;
							case 'chevron-dark':
								navText = {
									navText: ["<span class='vg-owl-chevron vg-owl-chevron-dark vg-owl-chevron-left'></span>", "<span class='vg-owl-chevron vg-owl-chevron-dark vg-owl-chevron-right'></span>"],
								};
								break;
							default:
								navText = {
									navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
								};
						}

						navigation = $.extend({
							nav: true
						}, navText);
					}

					let options = {
						items: items,
						loop: loop,
						autoplay: autoplay,
						autoplayTimeout: autoplayTimeout,
						margin: margin,
						stagePadding: stagePadding,
						dots: dots,
						smartSpeed: smartSpeed,
						fluidSpeed: fluidSpeed,
						autoWidth: autoWidth,
						autoHeight: autoHeight,
						responsive: responsive
					};

					options = $.extend(options, animatedOut, animatedIn, navigation);

					$self.owlCarousel(options);
				}
			});
		}
	}
};
